import { render, staticRenderFns } from "./SaitenInputScoreStamp.vue?vue&type=template&id=270ac1f7&scoped=true&"
import script from "./SaitenInputScoreStamp.vue?vue&type=script&lang=ts&"
export * from "./SaitenInputScoreStamp.vue?vue&type=script&lang=ts&"
import style0 from "./SaitenInputScoreStamp.vue?vue&type=style&index=0&id=270ac1f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270ac1f7",
  null
  
)

export default component.exports